import { Pipe, PipeTransform } from '@angular/core';
import { Pool } from '../models/pool';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'poolDataPreprocessing'
})
export class PoolDataPreprocessingPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe
  ) {

  }

  transform(pools: Pool[]): Pool[] {
    return pools && pools.map(pool => {
      return {
        ...pool, 
        simPoolConfig: {
          ...pool.simPoolConfig,
          limit_decimal: pool.simPoolConfig ? this.decimalPipe.transform(pool.simPoolConfig.limit, '1.0-0') : null
        }
      }
    });
  }

}
